<mat-card>
  <h2 translate>tracingReports.title</h2>
  <p translate>tracingReports.text</p>
  <mat-card-content>
    <form [formGroup]="searchDataForm" (ngSubmit)="onSearchClick(1)">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
          <scf-custom-select-search
            [id]="'macroChainSelect'"
            formControlName="macroChain"
            fxFlex="100"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [hasSelectOptionEmpty]="true"
            [showErrors]="searchDataForm?.controls?.macroChain?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
          <scf-custom-select-search
            [id]="'macroOfficeSelect'"
            formControlName="macroOffice"
            fxFlex="100"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [hasSelectOptionEmpty]="true"
            [showErrors]="searchDataForm?.controls?.macroOffice?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroChainUser || isMacroOfficeUser"></div>
        <mat-checkbox fxFlex="100" class="monthCheckBox" (change)="sendDateMonth($event)">
          <mat-label translate>sidenav.menu.reports.current-month</mat-label>
        </mat-checkbox>
        <div fxFlex="50" fxFlex.gt-sm="30">
          <mat-form-field appearance="outline">
            <mat-label translate>tracingReports.initialDate</mat-label>
            <input
              #inputInitialDate
              id="initialDateInput"
              matInput
              [matDatepicker]="datepickerInitialDate"
              formControlName="initialDate"
              [min]="minInitialDate"
              [max]="maxInitialDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
            <mat-datepicker id="initialDatePicker" startView="multi-year" #datepickerInitialDate></mat-datepicker>
            <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.required" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <mat-form-field appearance="outline">
            <mat-label translate>tracingReports.endDate</mat-label>
            <input
              #inputFinalDate
              id="finalDateInput"
              matInput
              [matDatepicker]="datepickerFinalDate"
              formControlName="finalDate"
              [max]="maxFinalDate"
              [min]="minDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
            <mat-datepicker id="finalDateInputpicker" startView="multi-year" #datepickerFinalDate></mat-datepicker>
            <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.required" translate> field.required </mat-error>
            <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
            <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="40">
          <scf-custom-select-search
            [id]="'prescriptorSelect'"
            formControlName="prescriptor"
            fxFlex="100"
            [dataInput]="prescriptorsList"
            [placeholder]="'tracingReports.selectPrescriptor'"
            [isMultiple]="true"
            [isRequired]="true"
            [showErrors]="searchDataForm?.controls?.prescriptor?.errors"
            (onSelectCheckAll)="setCheckAll($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50">
          <scf-custom-select-search
            [id]="'establishmentSelect'"
            formControlName="establishment"
            fxFlex="100"
            [dataInput]="establishmentsList"
            [placeholder]="'tracingReports.selectEstablishment'"
            [isMultiple]="true"
            [isRequired]="true"
            [showErrors]="searchDataForm?.controls?.establishment?.errors"
            (onSelectCheckAll)="setCheckAll($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50">
          <scf-custom-select-search
            [id]="'statusSelect'"
            formControlName="status"
            fxFlex="100"
            [dataInput]="statusList"
            [placeholder]="'tracingReports.selectStatus'"
            [isRequired]="true"
            [isMultiple]="false"
            [showErrors]="searchDataForm?.controls?.status?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="100">
          <div fxFlex="100" fxFlexAlign="start" fxLayoutAlign="end" class="request__button-calculate">
            <button
              id="searchTracingReports"
              mat-flat-button
              type="submit"
              color="accent"
              [disabled]="searchDataForm.invalid"
            >
              <span>{{ 'tracingReports.consult' | translate | uppercase }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="macros">
  <!-- HEADER -->
  <div
    class="panel-request__card-header"
    *ngIf="macros && macros.length > 0"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
  >
    <h2 translate>tracingReports.results</h2>
    <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.gt-xs="end center" fxLayoutGap="16px">
      <button id="btnChangeColumns" mat-stroked-button color="accent" (click)="changeColumns()">
        <mat-icon class="icon-ic_list_checked"></mat-icon>
        <span>{{ 'tracingReports.btnChangeColumns' | translate | uppercase }}</span>
      </button>
      <button id="btnexportMacro" mat-stroked-button color="accent" (click)="exportMacro()">
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'tracingReports.btnexportMacro' | translate | uppercase }}</span>
      </button>
    </div>
  </div>
  <mat-card-content>
    <div *ngIf="macros && dataSource.data?.length > 0; else noOperations" class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="macros" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="request">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.request</th>
          <td mat-cell *matCellDef="let element">{{ element.request }}</td>
        </ng-container>
        <ng-container matColumnDef="operative">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.operative</th>
          <td mat-cell *matCellDef="let element">{{ element.operative }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.status</th>
          <td mat-cell *matCellDef="let element">{{ element.status }}</td>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.startDate</th>
          <td mat-cell *matCellDef="let element">{{ element.startDate }}</td>
        </ng-container>
        <ng-container matColumnDef="amountCaper">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.amountCaper</th>
          <td mat-cell *matCellDef="let element">{{ element.amountCaper }}</td>
        </ng-container>
        <ng-container matColumnDef="batchPayments">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.batchPayments</th>
          <td mat-cell *matCellDef="let element">{{ element.batchPayments }}</td>
        </ng-container>
        <ng-container matColumnDef="brandCard">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.brandCard</th>
          <td mat-cell *matCellDef="let element">{{ element.brandCard }}</td>
        </ng-container>
        <ng-container matColumnDef="businessName">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.businessName</th>
          <td mat-cell *matCellDef="let element">{{ element.businessName }}</td>
        </ng-container>
        <ng-container matColumnDef="cae">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.cae</th>
          <td mat-cell *matCellDef="let element">{{ element.cae }}</td>
        </ng-container>
        <ng-container matColumnDef="canal">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.canal</th>
          <td mat-cell *matCellDef="let element">{{ element.canal }}</td>
        </ng-container>

        <ng-container matColumnDef="cardType">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.cardType</th>
          <td mat-cell *matCellDef="let element">{{ element.cardType }}</td>
        </ng-container>

        <ng-container matColumnDef="codEstablishment">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.codEstablishment</th>
          <td mat-cell *matCellDef="let element">{{ element.codEstablishment }}</td>
        </ng-container>

        <ng-container matColumnDef="chainDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.chainDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.chainDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="consumptionRef">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.consumptionRef</th>
          <td mat-cell *matCellDef="let element">{{ element.consumptionRef }}</td>
        </ng-container>

        <ng-container matColumnDef="contract">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.contract</th>
          <td mat-cell *matCellDef="let element">{{ element.contract }}</td>
        </ng-container>

        <ng-container matColumnDef="customerDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.customerDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.customerDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="customerNif">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.customerNif</th>
          <td mat-cell *matCellDef="let element">{{ element.customerNif }}</td>
        </ng-container>

        <ng-container matColumnDef="descEstablishment">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.descEstablishment</th>
          <td mat-cell *matCellDef="let element">{{ element.descEstablishment }}</td>
        </ng-container>

        <ng-container matColumnDef="descSeller">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.descSeller</th>
          <td mat-cell *matCellDef="let element">{{ element.descSeller }}</td>
        </ng-container>

        <ng-container matColumnDef="embroideryFrame">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.embroideryFrame</th>
          <td mat-cell *matCellDef="let element">{{ element.embroideryFrame }}</td>
        </ng-container>

        <ng-container matColumnDef="entry">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.entry</th>
          <td mat-cell *matCellDef="let element">{{ element.entry }}</td>
        </ng-container>

        <ng-container matColumnDef="externalCommercialDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.externalCommercialDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.externalCommercialDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="financeAmount">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.financeAmount</th>
          <td mat-cell *matCellDef="let element">{{ element.financeAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="financedAmount">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.financedAmount</th>
          <td mat-cell *matCellDef="let element">{{ element.financedAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="incentiveAssets">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.incentiveAssets</th>
          <td mat-cell *matCellDef="let element">{{ element.incentiveAssets }}</td>
        </ng-container>

        <ng-container matColumnDef="incentiveAssetsPer">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.incentiveAssetsPer</th>
          <td mat-cell *matCellDef="let element">{{ element.incentiveAssetsPer }}</td>
        </ng-container>

        <ng-container matColumnDef="incentiveSure">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.incentiveSure</th>
          <td mat-cell *matCellDef="let element">{{ element.incentiveSure }}</td>
        </ng-container>

        <ng-container matColumnDef="incentiveSurePer">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.incentiveSurePer</th>
          <td mat-cell *matCellDef="let element">{{ element.incentiveSurePer }}</td>
        </ng-container>

        <ng-container matColumnDef="indRappel">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.indRappel</th>
          <td mat-cell *matCellDef="let element">{{ element.indRappel }}</td>
        </ng-container>

        <ng-container matColumnDef="initialTIN">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.initialTIN</th>
          <td mat-cell *matCellDef="let element">{{ element.initialTIN }}</td>
        </ng-container>

        <ng-container matColumnDef="initialTerm">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.initialTerm</th>
          <td mat-cell *matCellDef="let element">{{ element.initialTerm }}</td>
        </ng-container>

        <ng-container matColumnDef="interestDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.interestDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.interestDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="legalId">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.legalId</th>
          <td mat-cell *matCellDef="let element">{{ element.legalId }}</td>
        </ng-container>

        <ng-container matColumnDef="ownId">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.ownId</th>
          <td mat-cell *matCellDef="let element">{{ element.ownId }}</td>
        </ng-container>

        <ng-container matColumnDef="proconCod">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.proconCod</th>
          <td mat-cell *matCellDef="let element">{{ element.proconCod }}</td>
        </ng-container>

        <ng-container matColumnDef="proconDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.proconDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.proconDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="profinDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.profinDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.profinDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="registration">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.registration</th>
          <td mat-cell *matCellDef="let element">{{ element.registration }}</td>
        </ng-container>

        <ng-container matColumnDef="resolutionDate">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.resolutionDate</th>
          <td mat-cell *matCellDef="let element">{{ element.resolutionDate }}</td>
        </ng-container>

        <ng-container matColumnDef="sectorCod">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.sectorCod</th>
          <td mat-cell *matCellDef="let element">{{ element.sectorCod }}</td>
        </ng-container>

        <ng-container matColumnDef="sectorDesc">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.sectorDesc</th>
          <td mat-cell *matCellDef="let element">{{ element.sectorDesc }}</td>
        </ng-container>

        <ng-container matColumnDef="seller">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.seller</th>
          <td mat-cell *matCellDef="let element">{{ element.seller }}</td>
        </ng-container>

        <ng-container matColumnDef="signatureType">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.signatureType</th>
          <td mat-cell *matCellDef="let element">{{ element.signatureType }}</td>
        </ng-container>

        <ng-container matColumnDef="statusContract">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.statusContract</th>
          <td mat-cell *matCellDef="let element">{{ element.statusContract }}</td>
        </ng-container>

        <ng-container matColumnDef="cancellationDate">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.cancellationDate</th>
          <td mat-cell *matCellDef="let element">{{ element.cancellationDate }}</td>
        </ng-container>

        <ng-container matColumnDef="sure">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.sure</th>
          <td mat-cell *matCellDef="let element">{{ element.sure }}</td>
        </ng-container>

        <ng-container matColumnDef="tariff">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.tariff</th>
          <td mat-cell *matCellDef="let element">{{ element.tariff }}</td>
        </ng-container>

        <ng-container matColumnDef="teamValue">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.teamValue</th>
          <td mat-cell *matCellDef="let element">{{ element.teamValue }}</td>
        </ng-container>

        <ng-container matColumnDef="transferredAmount">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.transferredAmount</th>
          <td mat-cell *matCellDef="let element">{{ element.transferredAmount }}</td>
        </ng-container>

        <ng-container matColumnDef="vehicleBrand">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.vehicleBrand</th>
          <td mat-cell *matCellDef="let element">{{ element.vehicleBrand }}</td>
        </ng-container>

        <ng-container matColumnDef="vehicleModel">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.vehicleModel</th>
          <td mat-cell *matCellDef="let element">{{ element.vehicleModel }}</td>
        </ng-container>
        <ng-container matColumnDef="certifiedPayment">
          <th mat-header-cell *matHeaderCellDef translate>tracingReports.certifiedPayment</th>
          <td mat-cell *matCellDef="let element">{{ element.certifiedPayment }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div fxLayout="row" class="buttons-paginator">
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onClickNavigatePage(1)"
          [disabled]="page == 1"
        >
          <mat-icon [class]="'icon-ic_to_beginning'"></mat-icon>
        </button>
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onClickNavigatePage(page - 1)"
          [disabled]="page == 1"
        >
          <mat-icon [class]="'icon-ic_chevron_left'"></mat-icon>
        </button>
        <button
          id="nextPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onClickNavigatePage(page + 1)"
          [disabled]="page == totalPages"
        >
          <mat-icon [class]="'icon-ic_chevron_right'"></mat-icon>
        </button>
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onClickNavigatePage(totalPages)"
          [disabled]="page == totalPages"
        >
          <mat-icon [class]="'icon-ic_to_end'"></mat-icon>
        </button>
      </div>
    </div>

    <ng-template #noOperations>
      <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
        <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
